import { useAtomValue } from 'jotai';
import { ArrowLeft, Bell, Crown } from '@phosphor-icons/react';
import Logo from './Logo';
import { drumUserProfileAtom } from '../store/drumAppAtoms';
import type { MidiStatus } from '../hooks/useMidiDrums';

interface AppHeaderProps {
  title: string;
  onBack?: (() => void) | null;
  onOpenSubscription: () => void;
  onOpenNotices: () => void;
  onOpenProfile: () => void;
  onLogoClick: () => void;
  language: string;
  midiStatus: MidiStatus;
  midiDeviceName: string;
  onMidiScan: () => void;
}

function AppHeader({ title, onBack, onOpenSubscription, onOpenNotices, onOpenProfile, onLogoClick, language, midiStatus, midiDeviceName, onMidiScan }: AppHeaderProps) {
  const user = useAtomValue(drumUserProfileAtom);
  const midiConnected = midiStatus === 'connected';
  const midiLabel = language === 'ko'
    ? (midiConnected ? 'MIDI 연결됨' : midiStatus === 'checking' ? 'MIDI 권한 확인 중' : midiStatus === 'unsupported' ? 'MIDI 미지원' : midiStatus === 'denied' ? 'MIDI 권한 필요' : 'MIDI 연결 안 됨')
    : (midiConnected ? 'MIDI CONNECTED' : midiStatus === 'checking' ? 'CHECKING MIDI' : midiStatus === 'unsupported' ? 'MIDI NOT SUPPORTED' : midiStatus === 'denied' ? 'MIDI PERMISSION NEEDED' : 'MIDI NOT CONNECTED');
  return (
    <header className="app-header">
      <div className="header-title">
        {onBack ? (
          <button className="icon-button" onClick={onBack} aria-label="Go back"><ArrowLeft /></button>
        ) : (
          <button className="logo-button" type="button" onClick={onLogoClick} aria-label="Go to home">
            <Logo compact />
          </button>
        )}
        <strong>{title}</strong>
      </div>
      <div className="player-status">
        <button type="button" className={`header-midi-status ${midiConnected ? 'connected' : 'disconnected'}`} onClick={onMidiScan} title={midiDeviceName || midiLabel}><i />{midiLabel}</button>
        <button className="pass-chip" onClick={onOpenSubscription}><Crown weight="fill" /> {language === 'ko' ? '드럼하이 패스' : 'DRUM Hi Pass'}</button>
        <button className="icon-button" onClick={onOpenNotices} aria-label="Notices"><Bell /></button>
        <button className="dh-avatar" type="button" onClick={onOpenProfile} aria-label="My profile">
          {user?.picture ? <img src={user.picture} alt={user.name} /> : <span>{(user?.name || '?').trim().slice(0, 1).toUpperCase() || '?'}</span>}
        </button>
      </div>
    </header>
  );
}

export default AppHeader;
